import { languageIndex } from "@utils";
export const fields = (language) => {
    const index = languageIndex(language);
    return {
        startDate: ["Start Date", "Дата начала"][index],
        endDate: ["End Date", "Дата конца"][index],
        present: ["Present", "По настоящее время"][index],
    };
};
